import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-pending-approval',
  templateUrl: './pending-approval.component.html',
  styleUrls: ['./pending-approval.component.scss']
})
export class PendingApprovalComponent implements OnInit {

  constructor(
    private router: Router
  ) {

    let status = localStorage.getItem('has_onboarded')
    if (status == 'false') {
      this.router.navigate(['/onboarding'])
    }
    else if (localStorage.getItem('is_approved') == 'true') {
      this.router.navigate(['/admin/dashboard'])
    }
    else {
      return
    }

  }

  ngOnInit(): void {
  }

}
